export default __webpack_public_path__ + "static/media/body-legs.80715ee5.png";